export default "__VITE_ASSET__DUEWfaEh__"